<template>
  <BaseDialogForm
    v-model="showAddItemForm"
    :title="`Add ${itemModule.item}`"
    :nonFieldErrors="formErrors.non_field_errors"
  >
    <template #content>
      <v-form
        v-model="isValid"
        ref="integrationItemForm"
        :key="formCount"
        @submit.prevent="submitForm"
      >
        <v-row class="ma-0">
          <v-col cols="12" lg="7">
            <v-card outlined class="pa-6 rounded-lg h-100">
              <v-row>
                <v-col cols="12">
                  <span class="text-subtitle-1 font-weight-bold">
                    Basic Information
                  </span>
                </v-col>
                <v-col cols="12" lg="6">
                  <p class="text-caption text-truncate mb-0">
                    actual value: {{ actualItemDetails.item_no }}
                  </p>
                  <InputField
                    id="item_no"
                    v-model="itemDetails.item_no"
                    label="Item No"
                    name="item_no"
                    :required="true"
                    :error-messages="formErrors.item_no"
                    @input="delete formErrors.item_no"
                  />
                </v-col>
                <v-col cols="12" lg="6">
                  <p class="text-caption text-truncate mb-0">
                    actual value: {{ actualItemDetails.storage_type }}
                  </p>
                  <SelectField
                    id="storage_type"
                    v-model="itemDetails.storage_type"
                    label="Storage type*"
                    name="storage_type"
                    :itemsList="storageType"
                    :rules="[(val) => !!val || 'Storage type is required']"
                    hide-details="auto"
                    item-text="name"
                    item-value="id"
                    :error-messages="formErrors.storage_type"
                    @input="delete formErrors.storage_type"
                  />
                </v-col>
                <v-col cols="12">
                  <p class="text-caption text-truncate mb-0">
                    actual value: {{ actualItemDetails.description }}
                  </p>
                  <InputField
                    id="description"
                    v-model="itemDetails.description"
                    label="Description"
                    name="description"
                    :required="true"
                    :error-messages="formErrors.description"
                    @input="delete formErrors.description"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <v-col cols="12" lg="5">
            <v-card outlined class="pa-6 rounded-lg h-100">
              <v-row>
                <v-col cols="12">
                  <span class="text-subtitle-1 font-weight-bold">
                    {{ itemModule.item }} Size Information
                  </span>
                </v-col>
                <v-col cols="12" lg="6">
                  <p class="text-caption text-truncate mb-0">
                    actual value: {{ actualItemDetails.length }}
                  </p>
                  <InputField
                    id="length"
                    type="number"
                    step="0.0001"
                    min="0.0001"
                    name="length"
                    v-model="itemDetails.length"
                    label="Length"
                    :suffix="UOM.CM"
                    :required="true"
                    :rules="[
                      (val) => val > 0 || 'Negative Numbers are not allowed',
                    ]"
                    :error-messages="formErrors.length"
                    @input="delete formErrors.length"
                  />
                </v-col>
                <v-col cols="12" lg="6">
                  <p class="text-caption text-truncate mb-0">
                    actual value: {{ actualItemDetails.width }}
                  </p>
                  <InputField
                    id="width"
                    type="number"
                    step="0.0001"
                    min="0.0001"
                    v-model="itemDetails.width"
                    name="width"
                    label="Width"
                    :suffix="UOM.CM"
                    :required="true"
                    :rules="[
                      (val) => val > 0 || 'Negative Numbers are not allowed',
                    ]"
                    :error-messages="formErrors.width"
                    @input="delete formErrors.width"
                  />
                </v-col>
                <v-col cols="12" lg="6">
                  <p class="text-caption text-truncate mb-0">
                    actual value: {{ actualItemDetails.height }}
                  </p>
                  <InputField
                    id="height"
                    type="number"
                    step="0.0001"
                    min="0.0001"
                    v-model="itemDetails.height"
                    name="height"
                    label="Height"
                    :suffix="UOM.CM"
                    :required="true"
                    :rules="[
                      (val) => val > 0 || 'Negative Numbers are not allowed',
                    ]"
                    :error-messages="formErrors.height"
                    @input="delete formErrors.height"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" lg="12">
            <v-card outlined class="pa-6 rounded-lg h-100">
              <v-row>
                <v-col cols="12">
                  <span class="text-subtitle-1 font-weight-bold">
                    {{ itemModule.item }} Weight Information
                  </span>
                </v-col>
                <v-col cols="12" lg="4">
                  <p class="text-caption text-truncate mb-0">
                    actual value: {{ actualItemDetails.weight }}
                  </p>
                  <InputField
                    id="weight"
                    type="number"
                    name="weight"
                    min="0.0001"
                    step="0.0001"
                    v-model="itemDetails.weight"
                    label="Weight"
                    :suffix="UOM.KG"
                    :required="true"
                    :rules="[
                      (val) => val > 0 || 'Negative Numbers are not allowed',
                    ]"
                    :error-messages="formErrors.weight"
                    @input="delete formErrors.weight"
                  />
                </v-col>
                <v-col cols="12" lg="4">
                  <p class="text-caption text-truncate mb-0">
                    actual value: {{ actualItemDetails.volume }}
                  </p>
                  <InputField
                    id="volume"
                    type="number"
                    name="volume"
                    step="0.0001"
                    min="0.0001"
                    v-model="itemDetails.volume"
                    label="Volume"
                    :suffix="UOM.CBM"
                    :required="true"
                    :rules="[
                      (val) => val > 0 || 'Negative Numbers are not allowed',
                    ]"
                    :error-messages="formErrors.volume"
                    @input="delete formErrors.volume"
                  />
                </v-col>
                <v-col cols="12" lg="4">
                  <p class="text-caption text-truncate mb-0">
                    actual value: {{ actualItemDetails.case_factor }}
                  </p>
                  <InputField
                    id="case_factor"
                    type="number"
                    step="0.0001"
                    name="case_factor"
                    min="0.0001"
                    v-model="itemDetails.case_factor"
                    label="Case Factor"
                    :required="true"
                    :rules="[
                      (val) => val > 0 || 'Negative Numbers are not allowed',
                    ]"
                    :error-messages="formErrors.case_factor"
                    @input="delete formErrors.case_factor"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #actions>
      <SecondaryButton
        id="itemReset"
        @click="resetForm()"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
      </SecondaryButton>
      <PrimaryButton
        id="itemSubmit"
        @click="submitForm()"
        :disabled="!isValid"
        btnClass="text-uppercase rounded-lg"
        name="Submit"
      >
      </PrimaryButton>
    </template>
  </BaseDialogForm>
</template>

<script>
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";
import { itemModule } from "@/utils/moduleMapping";
import { UOM } from "@/utils/fieldConstants";
import { itemNumberValidation } from "@/utils/functions";
import { bus } from "@/main.js";

export default {
  components: { BaseDialogForm },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    IntegrationItemRequestID: {
      type: Number,
    },
    storageType: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      UOM,
      itemNumberValidation,
      itemModule,
      fileInput: null,
      formCount: 0,
      isValid: true,
      itemDetails: {},
      actualItemDetails: {},
      actualFormErrors: {},
      formErrors: {},
      unitList: [],
    };
  },
  computed: {
    showAddItemForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    resetForm() {
      this.itemDetails = { ...this.actualItemDetails };
      this.formErrors = { ...this.actualFormErrors };
      if (this.itemDetails.storage_type) {
        let selectStorageType = this.storageType.find(
          (item) =>
            item.name.toLowerCase() ==
            this.itemDetails.storage_type.toLowerCase()
        );
        if (selectStorageType && selectStorageType.name) {
          this.itemDetails.storage_type = selectStorageType.id;
        } else {
          this.itemDetails.storage_type = null;
        }
      }
    },
    submitForm() {
      bus.$emit("showLoader", true);
      this.$api.item
        .integrationItemUpdate({ ...this.itemDetails })
        .then(() => {
          bus.$emit("showLoader", false);
          bus.$emit("showToastMessage", {
            message: "item created successfully",
            color: "success",
          });
          this.closeDialog();
          this.$emit("refresh-item-logs-list", this.oldId);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
          if ("non_field_errors" in err) {
            this.nonFieldError = err.non_field_errors;
          }
          this.formErrors = err.data;
        });
    },
    closeDialog() {
      this.showAddItemForm = false;
      this.itemDetails = {};
      this.formErrors = {};
      this.nonFieldError = [];
    },

    populateItemIntegrationForm(id) {
      this.$api.integration
        .getIntegrationItemDetails(id)
        .then((res) => {
          this.oldId = id;
          this.formErrors = res.data.error;
          this.itemDetails = res.data.payload;
          this.actualItemDetails = { ...res.data.payload };
          this.actualFormErrors = { ...res.data.error };
          if (this.itemDetails.storage_type) {
            let selectStorageType = this.storageType.find(
              (item) =>
                item.name.toLowerCase() ==
                this.itemDetails.storage_type.toLowerCase()
            );
            if (selectStorageType && selectStorageType.name) {
              this.itemDetails.storage_type = selectStorageType.id;
            } else {
              this.itemDetails.storage_type = null;
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style></style>
